<template>
	<BasicTile
		class="referral__steps-tile background-tile-big d-flex flex-column align-center justify-center pa-6 pt-10"
		:rounded="'rounded-16'">


		
		<span class="referral__steps-tile__step-chip rounded-pill px-7 py-3 button--secondary d-flex">
			Step-<slot name="step"></slot>
		</span>

		<v-icon class="referral__steps-tile__icon">
			<slot name="icon"></slot>
		</v-icon>


		<span class="referral__steps-tile__title">
			<slot name="title"></slot>
		</span>

		<span class="referral__steps-tile__description">
			<slot name="subtitle"></slot>
		</span>





	</BasicTile>
</template>



<script setup>
import BasicTile from '@/components/Tiles/Basic-Tile.vue';
</script>



<style scoped lang="scss">
// keep it here if we remove it, the icons shrink in size for some reason, not yet known to humanity.
.referral__steps-tile__icon {}
</style>
